<template>
  <div class="summary-box" :class="{'summar-box-2':isUi2 }">
    <b-container>
      <b-row >
        <b-col class="summary-head">
          <h4 v-if="!isUi2">List Usage</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-radio-group v-model = "listUsage" stacked>
            <b-form-radio v-for="item in listMultiplePrice"
                          :value = "item.MultipleId"
                          :key="item.MultipleId"
                          class="item">
              I will use the list {{item.Desc.toLowerCase()}}
              <span>(+{{item.price| numberFormat}})</span>
              <!--<span> TODO@PONY help information</span>-->
            </b-form-radio>
          </b-form-radio-group>
        </b-col>
      </b-row>
    </b-container>
  </div>

</template>

<script>
  import priceHelp from '@/assets/priceHelp'

  export default {
    components: {
    },
    data () {
      return {
        selected: 1
      }
    },
    props: {
      isUi2: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      listMultiplePrice () {
        if (this.$store.state.summary.UserPriceList && this.$store.state.summary.UserPriceList.ListMultiplePrice) {
          let lists = this.$store.state.summary.UserPriceList.ListMultiplePrice
          let order = JSON.parse(JSON.stringify(this.$store.state.order))
          order.ListUsage = 1
          let totalEstmCost = priceHelp.updatePrice(order).TotalEstmCost
          for (let i = 0; i < lists.length; i++) {
            order.ListUsage = lists[i].MultipleId
            order = priceHelp.updatePrice(order)
            lists[i].price = (order.ListUsage > 1 ? 1 : -1) * (order.TotalEstmCost - totalEstmCost)
          }
          return lists
        } else {
          return []
        }
      },
      listUsage: {
        get () {
          return this.$store.state.order.ListUsage
        },
        set (val) {
          this.$store.commit('order/saveKey', ['ListUsage', val])
          this.TotalEstmCost = this.order.TotalEstmCost
          this.$store.dispatch('order/calculatePrice')
        }
      },
      order () {
        return this.$store.state.order
      },
      created () {
        this.TotalEstmCost = this.order.TotalEstmCost
      }
    }
  }
</script>

<style scoped lang="scss">
.item {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/summary/MListUsage.vue